import React, { useContext } from 'react';
//@ts-ignore
import styled, { ThemeContext } from 'styled-components/native';
import { Image, View } from 'react-native';
import { useScreenDimensions } from 'use-dimensions';
import Typography, { TypographyType } from '../../../../presentational/atoms/typography';
import logoLargeBlack from '../../../../../base64Images/logo/logo-large-black';
import loginImage from '../../../../../base64Images/access-deny';
import { IThemePart } from '../../../../theme';
import Button from '../../../../presentational/atoms/button';
import LoginUtil from '../../../../../modules/auth/LoginUtil';
import { LoginUserContext } from '../../../../../modules/auth/LoginUserContext';
import { useHistory } from 'react-router';
import { useMeQuery } from '../../../../../graphql/api/API';
import ApolloClientFactory from '../../../../../graphql/client/ApolloClientFactory';

const Header = styled.View`
  display: flex;
  align-self: center;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
  width: 100%;
  height: 100px;
  padding-left: 20px;
  padding-top: 20px;
`;

const Container = styled.View`
  display: flex;
  align-self: center;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  width: 100%;
  height: calc(100vh - 100px);
`;

const LeftContainer = styled.View`
  flex: 1;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding-left: 50px;
`;

const RightContainer = styled.View`
  flex: 1;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-right: 50px;
`;

const RightContainerInner = styled.View`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const AccessDenyResetCompletePage = () => {
  const { width } = useScreenDimensions();
  const themeContext: IThemePart = useContext(ThemeContext);
  const [loginUser, setLoginUser] = useContext(LoginUserContext);
  const history = useHistory();
  return (
    <View style={{ paddingBottom: 50 }}>
      <Header>
        <Image
          source={{ uri: logoLargeBlack }}
          resizeMode="contain"
          style={{
            width: 300,
            height: 100,
          }}
        />
      </Header>
      <Container>
        <LeftContainer>
          <Image
            source={{ uri: loginImage }}
            resizeMode="contain"
            style={{
              width: Math.max(width / 4, 500),
              height: Math.max(width / 4, 500),
            }}
          />
        </LeftContainer>
        <RightContainer>
          <RightContainerInner>
            <Typography variant={TypographyType.Title} style={{ fontSize: 20, marginVertical: 30 }}>
              {`IPアドレス制限を解除しました`}
            </Typography>
            <Typography variant={TypographyType.Title} style={{ fontSize: 14 }}>
              {`現在はどのIPアドレスからでもアクセスが可能な状態です。${'\n'}再度、IPアドレス制限を有効にしたい場合には、${'\n'}IPアドレス制限の設定画面から、設定を変更してください。`}
            </Typography>
            <Button
              text="タイムデザイナーを利用する"
              style={{ marginTop: 10 }}
              onPress={() => {
                window.location.href = '/';
              }}
            />
          </RightContainerInner>
        </RightContainer>
      </Container>
    </View>
  );
};

export default React.memo(AccessDenyResetCompletePage);
